import { type FamilyProductName } from '../site-types';

export type DatasourceType = 'jira' | 'confluence';
type SupportedFieldTypes = JiraFieldTypes | ConfluenceFieldTypes;
type JiraFieldTypes = 'JIRA_ISSUE' | 'JIRA_ISSUE_DETAILS';
type ConfluenceFieldTypes = 'PAGE_LINK' | 'PAGE_LABELS' | 'PAGE_STATUS' | 'PAGE_DETAILS';

export interface DatasourceTypeConfig {
  datasourceId: string;
  productName: FamilyProductName;
  fieldType: {
    primary: SupportedFieldTypes;
    dependent?: SupportedFieldTypes;
  };
}

type DatasourceConfigType = {
  [key in DatasourceType]: DatasourceTypeConfig;
};

const DATASOURCE_CONFIG: DatasourceConfigType = {
  jira: {
    datasourceId: 'd8b75300-dfda-4519-b6cd-e49abbd50401',
    productName: 'jira',
    fieldType: {
      primary: 'JIRA_ISSUE',
      dependent: 'JIRA_ISSUE_DETAILS',
    },
  },
  confluence: {
    datasourceId: '768fc736-3af4-4a8f-b27e-203602bff8ca',
    productName: 'confluence',
    fieldType: {
      primary: 'PAGE_LINK',
      dependent: 'PAGE_DETAILS',
    },
  },
};

export function getDatasourceConfig(
  datasourceType: DatasourceType
): DatasourceTypeConfig {
  return DATASOURCE_CONFIG[datasourceType];
}

export function getDatasourceConfigFromId(
  datasourceId: string
): DatasourceTypeConfig | undefined {
  return Object.values(DATASOURCE_CONFIG).find(
    (config) => config.datasourceId === datasourceId
  );
}
